/* Optional local review notes. No authentication, order lookup or payment status. */
(() => {
  const key = '__easternJewelryOrderClarity';
  if (window[key]) { window[key].initialize(document); return; }
  function initialize(root) {
    root.querySelectorAll('[data-trust-checklist]').forEach(checklist => {
      if (checklist.dataset.bound) return;
      checklist.dataset.bound = 'true';
      const items = [...checklist.querySelectorAll('[data-trust-item]')];
      const count = checklist.querySelector('[data-trust-check-count]');
      const reset = checklist.querySelector('[data-trust-reset]');
      const update = () => {
        const checked = items.filter(item => item.checked).length;
        count.textContent = `${checked} of ${items.length} items noted.${checked === items.length ? ' This is your review, not order or payment verification.' : ''}`;
        reset.disabled = checked === 0;
      };
      items.forEach(item => item.addEventListener('change', update));
      reset.addEventListener('click', () => {
        items.forEach(item => { item.checked = false; });
        update(); items[0]?.focus();
      });
      reset.hidden = false; update();
    });
  }
  window[key] = { initialize };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
